import PropTypes from "prop-types";
import React, { forwardRef, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useUserInfo } from "../../../../context/UserContext";
import Button from "../../../shared/Button";
const EditProfileHeader = forwardRef(
  (
    {
      defaultImage,
      file,
      setfile,
      uploadImg,
      label,
      text,
      orange,
      className,
      id,
      avatarData,
      setavatarDatas,
      multiple = false,
      ...rest
    },
    ref
  ) => {
    const [imagePreviewUrl, setstateimagePreviewUrl] = useState("");
    useEffect(() => {
      if (file) {
        let reader = new FileReader();
        reader.onloadend = () => {
          setstateimagePreviewUrl(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }, []);

    const handleImageChange = e => {
      e.preventDefault();
      let reader = new FileReader();
      let file = e.target.files[0];
      if (!multiple) {
        setfile(file);
      } else {
        setfile(e.target.files);
      }

      reader.onloadend = () => {
        setstateimagePreviewUrl(reader.result);
      };
      const avatarData = new FormData();

      reader.readAsDataURL(file);
      if (typeof avatar !== "string") {
        avatarData.append("avatar", file);
      }
      setavatarDatas(avatarData);
    };
    const removeimage = () => {
      setfile();
    };
    const { userinfo } = useUserInfo();

    return (
      <div
        className={`EditProfileHeader d-flex-space relative ${className} ${orange
          ? "EditProfileHeader--orange"
          : ""}`}
      >
        <div>
          <div className="flex gap-[16px] EditProfileHeader--info items-center">
            {typeof file === "string"
              ? <div className="EditProfileHeader--cover">
                  <img src={file} />
                </div>
              : <div className="EditProfileHeader--cover">
                  {file
                    ? <img src={imagePreviewUrl} />
                    : <div className="defaultavatar" />}
                </div>}
            <div>
              <h6>
                {userinfo.data.user.full_name}
              </h6>
              <p className="mt-[4px]">۰۹۳۳۰۴۳۷۸۵۷</p>
            </div>
          </div>
        </div>
        <div className="EditProfileHeader--uploadcoverbox">
          <input
            type="file"
            className="EditProfileHeader__input "
            id={id ? id : "image__cover--perview"}
            onInput={handleImageChange}
            onFocus={e => (e.target.placeholder = "")}
            ref={ref}
            multiple={multiple}
            {...rest}
          />
          <div className="flex gap-[20px] mt-[20px] md:mt-[0] ">
            <label
              className="EditProfileHeader__label"
              htmlFor={id ? id : "image__cover--perview"}
            >
              <img src={uploadImg} />
              <div className="button button__primary">
                آپلود تصویر نمایه جدید
              </div>
            </label>
            <Button varient="gray" onClick={() => removeimage()}>
              حذف تصویر نمایه
            </Button>
          </div>
        </div>
      </div>
    );
  }
);

export default EditProfileHeader;
